import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: {
        if: [
          [
            {
              '!=': [
                {
                  '@': 'editingAward',
                },
                null,
              ],
            },
            'Edit award',
          ],
          'Create new Award',
        ],
      },
      type: 'details',
      content: {
        '{}': {
          fields: {
            '[]': [
              {
                '{}': {
                  id: 'code',
                  value: {
                    '@>': [
                      {
                        '@': 'editingAward',
                      },
                      'code',
                    ],
                  },
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId: 'attr:ent#!awards#!award:!code',
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'name',
                  value: {
                    '@>': [
                      {
                        '@': 'editingAward',
                      },
                      'name',
                    ],
                  },
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId: 'attr:ent#!awards#!award:!name',
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'fan',
                  value: {
                    '@>': [
                      {
                        '@': 'editingAward',
                      },
                      'fan',
                    ],
                  },
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId: 'attr:ent#!awards#!award:!fan',
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'fain',
                  value: {
                    '@>': [
                      {
                        '@': 'editingAward',
                      },
                      'fain',
                    ],
                  },
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId: 'attr:ent#!awards#!award:!fain',
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  value: {
                    '@>': [
                      {
                        '@': 'editingAward',
                      },
                      'awardDate',
                    ],
                  },
                  id: 'award_date',
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId: 'attr:ent#!awards#!award:!award_date',
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'budget',
                  value: {
                    '@>': [
                      {
                        '@': 'editingAward',
                      },
                      'budget',
                    ],
                  },
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId: 'attr:ent#!awards#!award:!budget',
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'sponsor',
                  value: {
                    '@>': [
                      {
                        '@': 'editingAward',
                      },
                      'sponsor',
                    ],
                  },
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId: 'attr:ent#!awards#!award:!sponsor',
                        },
                      },
                    },
                  },
                },
              },
            ],
          },
          onSave: {
            '{}': {
              action: {
                '{}': {
                  alias: 'sr.actions.save-award',
                },
              },
              variables: {
                '{}': {
                  awardId: {
                    '@$': 'awardId',
                  },
                  awardCode: '${field:code}',
                  awardFain: '${field:fain}',
                  awardFan: '${field:fan}',
                  awardName: '${field:name}',
                  awardBudget: '${field:budget}',
                  awardAwardDate: '${field:award_date}',
                  awardSponsor: '${field:sponsor}',
                },
              },
            },
          },
        },
      },
    },
  },
  subqueries: {
    editingAward: {
      selection: {
        '{}': {
          code: {
            '@.': '!code',
          },
          name: {
            '@.': '!name',
          },
          fan: {
            '@.': '!fan',
          },
          fain: {
            '@.': '!fain',
          },
          awardDate: {
            '@.': '!award_date',
          },
          budget: {
            '@.': '!budget',
          },
          sponsor: {
            '@.': '!sponsor',
          },
        },
      },
      target: 'ent:!awards:!award',
      quantity: 1,
      filter: {
        '=': [
          {
            '@.': '!id',
          },
          {
            '@$': 'awardId',
          },
        ],
      },
    },
  },
}
